// Barras verticales con:
//  - rótulos del eje X recortados (p.ej. "lun", "mar")
//  - % de participación sobre cada barra
// Recharts da control fino de ticks y labels que Tremor no expone.
import { BarChart, Bar, XAxis, YAxis, Cell, ResponsiveContainer, LabelList } from "recharts";

export interface PctBarDatum {
  label: string; // rótulo corto del eje X (ej. "lun")
  fullLabel?: string; // tooltip
  value: number;
  pct: number; // participación 0-100
}

interface PctBarsProps {
  data: PctBarDatum[];
  colors: string[];
  height?: number;
}

export default function PctBars({ data, colors, height = 180 }: PctBarsProps) {
  const max = Math.max(...data.map((d) => d.value), 1);
  return (
    <div style={{ height }} className="w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 18, right: 8, left: 8, bottom: 4 }}
          barCategoryGap="20%"
        >
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={{ stroke: "#cbd5e1" }}
            tickLine={false}
          />
          <YAxis hide domain={[0, max * 1.15]} />
          <Bar dataKey="value" radius={[4, 4, 0, 0]} isAnimationActive={false}>
            {data.map((_, i) => (
              <Cell key={i} fill={colors[i % colors.length]} />
            ))}
            <LabelList
              dataKey="pct"
              position="top"
              formatter={(v: number) => `${v.toFixed(1)}%`}
              style={{ fontSize: 10, fill: "#475569", fontWeight: 600 }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
